module.exports = __webpack_public_path__ + "img/bg-wave.65b17a21.svg";